var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _polygon, _path4, _polygon2, _polyline, _line, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _polygon3, _polygon4, _polygon5, _path5, _path6, _path7, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path8, _path9, _path10, _polygon6, _polygon7, _polygon8, _path11, _path12, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path13, _path14, _path15, _path16, _polygon15, _polygon16, _polygon17, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _polygon18, _polygon19, _polygon20, _path17, _path18, _rect43, _rect44, _rect45, _rect46, _rect47, _polyline2, _line2, _polyline3, _line3, _polyline4, _line4, _polyline5, _line5, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _line6, _line7, _line8, _rect59, _line9, _path19, _rect60, _rect61, _rect62, _path20, _path21, _path22, _path23, _path24, _path25, _rect63, _rect64, _rect65, _path26, _path27, _path28, _polygon21, _rect66, _polygon22, _path29, _path30, _g, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _line10, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot201(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 600 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ececec;}.cls-2{fill:#f0f0f0;}.cls-3,.cls-5,.cls-6{fill:#e1e1e1;}.cls-19,.cls-20,.cls-21,.cls-23,.cls-25,.cls-33,.cls-39,.cls-4{fill:none;}.cls-4{stroke:#e7e7e7;}.cls-19,.cls-20,.cls-21,.cls-22,.cls-25,.cls-26,.cls-4{stroke-miterlimit:10;}.cls-13,.cls-16,.cls-18,.cls-27,.cls-30,.cls-31,.cls-34,.cls-35,.cls-37,.cls-5{isolation:isolate;}.cls-6{opacity:0.8;}.cls-7{fill:#f5f5f5;}.cls-8{fill:#fafafa;}.cls-9{fill:#1a2e35;}.cls-10,.cls-11,.cls-13,.cls-14,.cls-15,.cls-17,.cls-24,.cls-26,.cls-28,.cls-34,.cls-35,.cls-37{fill:#fff;}.cls-10,.cls-18,.cls-30,.cls-34{opacity:0.2;}.cls-11,.cls-27,.cls-37{opacity:0.4;}.cls-12,.cls-22{fill:#007cff;}.cls-13,.cls-15{opacity:0.6;}.cls-16,.cls-29{opacity:0.1;}.cls-17{opacity:0.7;}.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-39{stroke:#fff;}.cls-20{stroke-dasharray:5.19 5.19;}.cls-21{stroke-dasharray:4.99 4.99;}.cls-23,.cls-33,.cls-39{stroke-linecap:round;stroke-linejoin:round;}.cls-23{stroke-width:1.5px;}.cls-24{opacity:0.5;}.cls-25,.cls-26{stroke:#007cff;}.cls-28{opacity:0.9;}.cls-31,.cls-35{opacity:0.3;}.cls-32{fill:#fcb373;}.cls-33{stroke:#1a2e35;stroke-width:0.5px;}.cls-36{fill:#cc7a63;}.cls-38{fill:#b84d3c;}.cls-39{stroke-width:2px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.77,
    y: 368.74,
    width: 546.47,
    height: 0.27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 482.28,
    y: 386.33,
    width: 36.2,
    height: 0.27
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 379.27,
    y: 389.3,
    width: 9.5,
    height: 0.27
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460.21,
    y: 376.18,
    width: 20.98,
    height: 0.27
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.1,
    y: 378.02,
    width: 47.21,
    height: 0.27
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.04,
    y: 378.02,
    width: 6.92,
    height: 0.27
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.46,
    y: 382.63,
    width: 102.38,
    height: 0.27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.81,320h-211a6.25,6.25,0,0,1-6.24-6.24V17.1a6.25,6.25,0,0,1,6.24-6.24H285.81A6.24,6.24,0,0,1,292,17.1V313.76A6.24,6.24,0,0,1,285.81,320ZM74.76,11.14a6,6,0,0,0-6,6V313.76a6,6,0,0,0,6,6H285.81a6,6,0,0,0,6-6V17.1a6,6,0,0,0-6-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.21,320h-211a6.25,6.25,0,0,1-6.24-6.24V17.1a6.25,6.25,0,0,1,6.24-6.24H522.21a6.24,6.24,0,0,1,6.23,6.24V313.76A6.24,6.24,0,0,1,522.21,320Zm-211-308.86a6,6,0,0,0-6,6V313.76a6,6,0,0,0,6,6H522.21a6,6,0,0,0,6-6V17.1a6,6,0,0,0-6-6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.59,58.06a5.36,5.36,0,0,0-5.35-5.35,5.5,5.5,0,0,0-1.53.23,12.53,12.53,0,0,0,.12-1.64A11.32,11.32,0,0,0,395.51,40a11.13,11.13,0,0,0-2.09.2,9.89,9.89,0,0,0-18.34,5h-.16a9.12,9.12,0,1,0,0,18.23h33.47A5.35,5.35,0,0,0,413.59,58.06Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "393.94 66.06 393.94 55.64 385.44 55.64 385.44 66.06 378.52 66.06 389.69 75.5 400.86 66.06 393.94 66.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.1,73.82A11.34,11.34,0,0,0,231.49,63a25,25,0,0,0,.25-3.48,24,24,0,0,0-24-24,24.74,24.74,0,0,0-4.43.41,21,21,0,0,0-39,10.62H164a19.36,19.36,0,1,0,0,38.72h71.11v0A11.34,11.34,0,0,0,246.1,73.82Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.33 74.7 186.33 96.83 204.38 96.83 204.38 74.7 219.07 74.7 195.35 54.66 171.63 74.7 186.33 74.7"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "255.16 129.1 255.16 99.34 346.29 99.34 346.29 128.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 302.07,
    y1: 71.29,
    x2: 302.07,
    y2: 129.01
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 285.27,
    y: 59.96,
    width: 33.59,
    height: 21.04,
    rx: 1.19
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 286.43,
    y: 62.43,
    width: 31.27,
    height: 17.73,
    rx: 0.42
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 238.36,
    y: 126.4,
    width: 33.59,
    height: 21.04,
    rx: 1.19
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 239.52,
    y: 128.87,
    width: 31.27,
    height: 17.73,
    rx: 0.42
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 285.27,
    y: 126.4,
    width: 33.59,
    height: 21.04,
    rx: 1.19
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 286.43,
    y: 128.87,
    width: 31.27,
    height: 17.73,
    rx: 0.42
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 329.57,
    y: 126.4,
    width: 33.59,
    height: 21.04,
    rx: 1.19
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.73,
    y: 128.87,
    width: 31.27,
    height: 17.73,
    rx: 0.42
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 295.25,
    y: 92.52,
    width: 13.64,
    height: 13.64,
    rx: 0.88,
    transform: "translate(18.23 242.69) rotate(-45)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 101.31,
    y: 84.85,
    width: 23.77,
    height: 14.25,
    rx: 0.87
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 89.17,
    y: 115.49,
    width: 19.23,
    height: 10.87,
    rx: 0.87
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 118.34,
    y: 115.49,
    width: 19.23,
    height: 10.87,
    rx: 0.87
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.54,
    y: 138.5,
    width: 10.09,
    height: 9.29,
    rx: 0.87
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.36,
    y: 138.5,
    width: 10.09,
    height: 9.29,
    rx: 0.87
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.17,
    y: 138.5,
    width: 10.09,
    height: 9.29,
    rx: 0.87
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.89,
    y: 138.5,
    width: 10.09,
    height: 9.29,
    rx: 0.87
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.8,
    y: 138.5,
    width: 10.09,
    height: 9.29,
    rx: 0.87
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "126.86 115.49 127.95 115.49 127.95 107.84 113.74 107.84 113.74 99.1 112.65 99.1 112.65 107.84 98.44 107.84 98.44 115.49 99.53 115.49 99.53 108.93 126.86 108.93 126.86 115.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.44 132.98 84.23 132.98 84.23 138.44 85.33 138.44 85.33 134.07 98.44 134.07 98.44 138.44 99.53 138.44 99.53 126.42 98.44 126.42 98.44 132.98"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "127.95 134.07 127.95 126.42 126.86 126.42 126.86 134.07 113.74 134.07 113.74 138.44 114.83 138.44 114.83 135.16 126.86 135.16 126.86 138.44 127.95 138.44 127.95 135.16 139.97 135.16 139.97 138.44 141.07 138.44 141.07 134.07 127.95 134.07"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M443.17,88.27v7.85l4,.38a21,21,0,0,0,3,7.26l-2.59,3.13,5.55,5.56,3.14-2.6a21,21,0,0,0,7.25,3l.38,4h7.85l.38-4a21,21,0,0,0,7.25-3l3.14,2.6,5.55-5.56-2.59-3.13a21.19,21.19,0,0,0,3-7.26l4-.38V88.27l-4-.38a21.14,21.14,0,0,0-3-7.25l2.59-3.14L482.57,72l-3.14,2.6a21,21,0,0,0-7.25-3l-.38-4H464l-.38,4a21,21,0,0,0-7.25,3L453.18,72l-5.55,5.55,2.59,3.14a21,21,0,0,0-3,7.25Zm24.7-6.7A10.63,10.63,0,1,1,457.25,92.2,10.62,10.62,0,0,1,467.87,81.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M448.24,145.56a16.41,16.41,0,0,0,5.68-2.36l2.46,2,4.35-4.35-2-2.46a16.43,16.43,0,0,0,2.37-5.68l3.17-.3v-6.15l-3.17-.3a16.43,16.43,0,0,0-2.37-5.68l2-2.46-4.35-4.35-2.46,2a16.43,16.43,0,0,0-5.68-2.37l-.3-3.16h-6.15l-.3,3.16a16.43,16.43,0,0,0-5.68,2.37l-2.46-2L429,117.85l2,2.46a16.41,16.41,0,0,0-2.36,5.68l-3.17.3v6.15l3.17.3a16.41,16.41,0,0,0,2.36,5.68l-2,2.46,4.35,4.35,2.46-2a16.41,16.41,0,0,0,5.68,2.36l.3,3.17h6.15Zm-11.71-16.19a8.33,8.33,0,1,1,8.33,8.33A8.33,8.33,0,0,1,436.53,129.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M434.51,112.26l2.07,1.71,3.65-3.65-1.71-2.07a13.8,13.8,0,0,0,2-4.77l2.66-.25V98.06l-2.66-.25a13.8,13.8,0,0,0-2-4.77L440.23,91l-3.65-3.65L434.51,89a13.8,13.8,0,0,0-4.77-2l-.25-2.66h-5.17L424.07,87a13.8,13.8,0,0,0-4.77,2l-2.07-1.71L413.58,91,415.29,93a13.8,13.8,0,0,0-2,4.77l-2.66.25v5.17l2.66.25a13.8,13.8,0,0,0,2,4.77l-1.71,2.07,3.65,3.65,2.07-1.71a13.8,13.8,0,0,0,4.77,2l.25,2.66h5.17l.25-2.66A13.8,13.8,0,0,0,434.51,112.26Zm-14.6-11.62a7,7,0,1,1,7,7A7,7,0,0,1,419.91,100.64Z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 433.6,
    y: 304.95,
    width: 73.39,
    height: 47.73
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 436.28,
    y: 313.9,
    width: 68.02,
    height: 36.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 441.82,
    y: 319.34,
    width: 50.32,
    height: 1.57
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 441.82,
    y: 324.13,
    width: 24.14,
    height: 1.57
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 441.82,
    y: 328.93,
    width: 30.41,
    height: 1.57
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 441.82,
    y: 333.72,
    width: 10.72,
    height: 1.57
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 441.82,
    y: 338.52,
    width: 6.94,
    height: 1.57
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.1,
    y: 304.8,
    width: 52.22,
    height: 32.21,
    transform: "matrix(1, 0, 0, 1, -1.46, 0.48)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M99.06,329a1.12,1.12,0,0,1-.65-.21l-9.53-7a1.09,1.09,0,0,1-.44-.88,1,1,0,0,1,.44-.88l9.46-7.05a1.09,1.09,0,0,1,1.31,1.75L91.37,321l8.33,6.08a1.1,1.1,0,0,1,.24,1.53A1.11,1.11,0,0,1,99.06,329Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.42,329a1.1,1.1,0,0,1-.88-.44,1.09,1.09,0,0,1,.23-1.53l8.27-6.16-8.33-6.09A1.09,1.09,0,1,1,112,313l9.53,7a1.11,1.11,0,0,1,.45.88,1.13,1.13,0,0,1-.44.88l-9.47,7A1,1,0,0,1,111.42,329Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.75,329a1.13,1.13,0,0,1-.36-.06,1.09,1.09,0,0,1-.67-1.39l4.91-14a1.09,1.09,0,1,1,2.06.72l-4.91,14A1.08,1.08,0,0,1,102.75,329Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "392.23 405.73 400.25 405.73 411.18 345.35 403.16 345.35 392.23 405.73"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "392.23 405.73 400.25 405.73 411.18 345.35 403.16 345.35 392.23 405.73"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "392.23 405.73 398.06 405.73 408.99 345.35 403.16 345.35 392.23 405.73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M369.61,363.31h32.12a1.77,1.77,0,0,0,1.77-1.77h0a1.77,1.77,0,0,0-1.77-1.77H369.61a1.78,1.78,0,0,0-1.78,1.77h0A1.78,1.78,0,0,0,369.61,363.31Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M366,383.53h32.12a1.78,1.78,0,0,0,1.78-1.78h0a1.78,1.78,0,0,0-1.78-1.77H366a1.77,1.77,0,0,0-1.77,1.77h0A1.78,1.78,0,0,0,366,383.53Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "359.44 405.73 367.46 405.73 378.39 345.35 370.37 345.35 359.44 405.73"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "359.44 405.73 367.46 405.73 378.39 345.35 370.37 345.35 359.44 405.73"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "359.44 405.73 365.28 405.73 376.2 345.35 370.37 345.35 359.44 405.73"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "434.13 405.73 426.11 405.73 415.18 345.35 423.2 345.35 434.13 405.73"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "434.13 405.73 426.11 405.73 415.18 345.35 423.2 345.35 434.13 405.73"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "431.94 405.73 426.11 405.73 415.18 345.35 421.02 345.35 431.94 405.73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M420,363.31H387.9a1.77,1.77,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.77H420a1.78,1.78,0,0,1,1.78,1.77h0A1.78,1.78,0,0,1,420,363.31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M423.59,383.53H391.47a1.78,1.78,0,0,1-1.78-1.78h0a1.78,1.78,0,0,1,1.78-1.77h32.12a1.77,1.77,0,0,1,1.77,1.77h0A1.78,1.78,0,0,1,423.59,383.53Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M420,363.31H387.9a1.77,1.77,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.77H420a1.78,1.78,0,0,1,1.78,1.77h0A1.78,1.78,0,0,1,420,363.31Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M423.59,383.53H391.47a1.78,1.78,0,0,1-1.78-1.78h0a1.78,1.78,0,0,1,1.78-1.77h32.12a1.77,1.77,0,0,1,1.77,1.77h0A1.78,1.78,0,0,1,423.59,383.53Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "401.34 405.73 393.32 405.73 382.39 345.35 390.41 345.35 401.34 405.73"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "401.34 405.73 393.32 405.73 382.39 345.35 390.41 345.35 401.34 405.73"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "399.16 405.73 393.32 405.73 382.39 345.35 388.23 345.35 399.16 405.73"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 367.01,
    y: 342.47,
    width: 60.63,
    height: 5.76,
    rx: 1.19
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 367.01,
    y: 342.47,
    width: 24.66,
    height: 5.76,
    rx: 1.19
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 165.79,
    y: 357.21,
    width: 73.39,
    height: 47.73
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 165.79,
    y: 357.21,
    width: 73.39,
    height: 47.73
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 168.48,
    y: 366.16,
    width: 68.02,
    height: 36.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 174.02,
    y: 371.6,
    width: 50.32,
    height: 1.57
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 174.02,
    y: 376.39,
    width: 24.14,
    height: 1.57
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 174.02,
    y: 381.19,
    width: 30.41,
    height: 1.57
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 174.02,
    y: 385.98,
    width: 10.72,
    height: 1.57
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 174.02,
    y: 390.78,
    width: 6.94,
    height: 1.57
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "329.87 405.73 270.13 405.73 280.24 326.3 319.76 326.3 329.87 405.73"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "329.87 405.73 270.13 405.73 277.05 351.39 280.25 326.3 319.75 326.3 324.47 363.31 329.87 405.73"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "324.47 363.31 277.05 351.39 280.25 326.3 319.75 326.3 324.47 363.31"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M440.84,130.46H159.16a7.21,7.21,0,0,0-7.21,7.21v190.7a7.21,7.21,0,0,0,7.21,7.21H440.84a7.21,7.21,0,0,0,7.21-7.21V137.67A7.21,7.21,0,0,0,440.84,130.46Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M440.84,130.46H159.16a7.21,7.21,0,0,0-7.21,7.21v190.7a7.21,7.21,0,0,0,7.21,7.21H440.84a7.21,7.21,0,0,0,7.21-7.21V137.67A7.21,7.21,0,0,0,440.84,130.46Z"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 161.43,
    y: 137.52,
    width: 277.14,
    height: 183.89
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 248.69,
    y: 399.76,
    width: 102.62,
    height: 5.87,
    rx: 1.04
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 248.69,
    y: 399.76,
    width: 102.62,
    height: 5.87,
    rx: 1.04
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 161.43,
    y: 137.7,
    width: 277.14,
    height: 27.41
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.43,
    y: 165.43,
    width: 118.76,
    height: 155.98
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "395.92 205.45 395.92 207.95 393.42 207.95"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 388.23,
    y1: 207.95,
    x2: 297.38,
    y2: 207.95
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "294.78 207.95 292.28 207.95 292.28 205.45"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 292.28,
    y1: 200.46,
    x2: 292.28,
    y2: 153.03
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "292.28 150.53 292.28 148.03 294.78 148.03"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 299.97,
    y1: 148.03,
    x2: 390.82,
    y2: 148.03
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "393.42 148.03 395.92 148.03 395.92 150.53"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 395.92,
    y1: 155.52,
    x2: 395.92,
    y2: 202.95
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 394.19,
    y: 146.3,
    width: 3.47,
    height: 3.47
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 394.19,
    y: 206.22,
    width: 3.47,
    height: 3.46
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 290.55,
    y: 146.3,
    width: 3.47,
    height: 3.47
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 290.55,
    y: 206.22,
    width: 3.47,
    height: 3.46
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 342.37,
    y: 146.3,
    width: 3.46,
    height: 3.46
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 342.37,
    y: 206.22,
    width: 3.46,
    height: 3.47
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 394.19,
    y: 176.26,
    width: 3.47,
    height: 3.47
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 290.55,
    y: 176.26,
    width: 3.47,
    height: 3.47
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.08,
    y: 168.16,
    width: 29.5,
    height: 10.91,
    rx: 1.89
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 315.36,
    y: 168.16,
    width: 29.5,
    height: 10.91,
    rx: 1.89
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 259.08,
    y: 301.05,
    width: 29.5,
    height: 10.91,
    rx: 1.89
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 420.28,
    y1: 147.44,
    x2: 429.51,
    y2: 147.44
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 420.28,
    y1: 151.81,
    x2: 429.51,
    y2: 151.81
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 420.28,
    y1: 156.19,
    x2: 429.51,
    y2: 156.19
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 180.22,
    y: 189.61,
    width: 92.96,
    height: 92.96
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 219.13,
    y1: 197.21,
    x2: 219.13,
    y2: 277.39
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M259.22,277.39h0a40.09,40.09,0,0,1-40.09-40.09h0a40.09,40.09,0,0,1,40.09-40.09h0"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 257.49,
    y: 195.48,
    width: 3.47,
    height: 3.46
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 257.49,
    y: 275.66,
    width: 3.47,
    height: 3.46
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 217.4,
    y: 235.57,
    width: 3.47,
    height: 3.46
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M220,197.21a.9.9,0,1,1-.9-.9A.9.9,0,0,1,220,197.21Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M220,277.39a.9.9,0,1,1-.9-.9A.9.9,0,0,1,220,277.39Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M373.15,302.37H345a8.13,8.13,0,0,1-8.13-8.13h0A8.13,8.13,0,0,1,345,286.1h28.14a8.13,8.13,0,0,1,8.13,8.14h0A8.13,8.13,0,0,1,373.15,302.37Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M397.87,233H310.94a1.78,1.78,0,0,1-1.78-1.78h0a1.78,1.78,0,0,1,1.78-1.78h86.93a1.78,1.78,0,0,1,1.78,1.78h0A1.78,1.78,0,0,1,397.87,233Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M397.87,246H310.94a1.78,1.78,0,0,1-1.78-1.78h0a1.78,1.78,0,0,1,1.78-1.77h86.93a1.78,1.78,0,0,1,1.78,1.77h0A1.78,1.78,0,0,1,397.87,246Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M397.87,259H343.73A1.78,1.78,0,0,1,342,257.2h0a1.78,1.78,0,0,1,1.78-1.77h54.14a1.78,1.78,0,0,1,1.78,1.77h0A1.78,1.78,0,0,1,397.87,259Z"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 170.19,
    y: 145.29,
    width: 6.14,
    height: 6.14
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 182.13,
    y: 145.29,
    width: 6.14,
    height: 6.14,
    rx: 1.44
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 194.07,
    y: 145.29,
    width: 6.14,
    height: 6.14,
    rx: 2.57
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M189,296.72v-2.39l-1.23-.12a6.56,6.56,0,0,0-.92-2.21l.79-1L186,289.35l-1,.79a6.56,6.56,0,0,0-2.21-.92l-.12-1.23h-2.39l-.12,1.23a6.64,6.64,0,0,0-2.21.92l-1-.79-1.7,1.69.8,1a6.17,6.17,0,0,0-.92,2.21l-1.24.12v2.39l1.24.12a6.25,6.25,0,0,0,.92,2.21l-.8.95,1.7,1.69,1-.79a6.25,6.25,0,0,0,2.21.92l.12,1.23h2.39l.12-1.23a6.17,6.17,0,0,0,2.21-.92l1,.79,1.69-1.69-.79-.95a6.64,6.64,0,0,0,.92-2.21Zm-7.53,2a3.24,3.24,0,1,1,3.24-3.24A3.24,3.24,0,0,1,181.49,298.76Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M198.72,303.48V301.6l-1-.09a5,5,0,0,0-.72-1.73l.62-.75-1.32-1.33-.75.62a5.05,5.05,0,0,0-1.74-.72l-.09-1h-1.87l-.09,1a5.05,5.05,0,0,0-1.74.72l-.74-.62L188,299l.62.75a5,5,0,0,0-.72,1.73l-1,.09v1.88l1,.09a5.08,5.08,0,0,0,.72,1.73l-.62.75,1.33,1.32.74-.62a5.05,5.05,0,0,0,1.74.72l.09,1h1.87l.09-1a5.05,5.05,0,0,0,1.74-.72l.75.62,1.32-1.32-.62-.75a5.08,5.08,0,0,0,.72-1.73Zm-5.9,1.6a2.54,2.54,0,1,1,2.53-2.54A2.54,2.54,0,0,1,192.82,305.08Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189,308.8v-1.58l-.81-.07a4.19,4.19,0,0,0-.61-1.46l.52-.63L187,304l-.63.52a4.18,4.18,0,0,0-1.46-.6l-.07-.82h-1.58l-.07.82a4.18,4.18,0,0,0-1.46.6l-.63-.52L180,305.06l.52.63a4.19,4.19,0,0,0-.61,1.46l-.81.07v1.58l.81.08a4.23,4.23,0,0,0,.61,1.45L180,311l1.11,1.11.63-.52a4.19,4.19,0,0,0,1.46.61l.07.81h1.58l.07-.81a4.19,4.19,0,0,0,1.46-.61l.63.52,1.11-1.11-.52-.63a4.23,4.23,0,0,0,.61-1.45Zm-5,1.34a2.13,2.13,0,1,1,2.13-2.13A2.13,2.13,0,0,1,184.06,310.14Z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "395.28 147.41 399.92 159.81 407.67 152.05 395.28 147.41"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 402.57,
    y: 153.21,
    width: 2.44,
    height: 5.43,
    transform: "translate(8.01 331.2) rotate(-45)"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "407.67 152.05 395.28 147.41 399.92 159.81 402.93 156.79 404.85 158.71 406.58 156.98 404.66 155.06 407.67 152.05"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M205.42,191.71l11.66,4.36L211,190a1.21,1.21,0,0,1-1.44-.19,1.21,1.21,0,0,1,1.71-1.7,1.18,1.18,0,0,1,.18,1.43l6.12,6.11L213.17,184l-3.86.86-.15-1.4-.73-.73L204.15,187l.73.73,1.4.15Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M205.42,191.71l11.66,4.36L211,190a1.21,1.21,0,0,1-1.44-.19,1.21,1.21,0,0,1,1.71-1.7,1.18,1.18,0,0,1,.18,1.43l6.12,6.11L213.17,184l-3.86.86-.15-1.4-.73-.73L204.15,187l.73.73,1.4.15Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "201.96 137.52 160.89 290.99 160.89 137.52 201.96 137.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "248.31 137.52 199.1 321.41 165.2 321.41 214.4 137.52 248.31 137.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "297.61 137.52 248.39 321.41 233.06 321.41 282.27 137.52 297.61 137.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "343 137.52 293.78 321.41 288.3 321.41 337.51 137.52 343 137.52"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M509.74,178.09c3.87,4.48,23.61,42.5,19.8,51.37s-35.44-1.35-35.44-1.35L496,215.58s12.29.43,13.47-.73-16.62-18.94-16.62-18.94Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M529.54,229.47a4.81,4.81,0,0,1-2.31,2.34l0,0c-.2.1-.42.2-.63.28l-.09,0a6,6,0,0,1-.6.2,12.87,12.87,0,0,1-2.74.57c-.26,0-.52.06-.79.08l-1.19.07-1,0c-10.6,0-26-5-26-5l1.9-12.53s12.28.44,13.46-.73c.28-.29-.56-1.56-2-3.32l0,0c-3.48-4.27-10.44-11.39-13.31-14.29l-1.3-1.31,16.9-17.82C513.61,182.56,533.35,220.58,529.54,229.47Z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M527.23,231.81l0,0c-.2.1-.42.2-.63.28l-.09,0a6,6,0,0,1-.6.2,12.87,12.87,0,0,1-2.74.57c-.26,0-.52.06-.79.08l-1.19.07-1,0c-10.6,0-26-5-26-5l1.9-12.53s13.83,1.17,15,0l0-.06c.21-.46-1.32-2-3.58-4l0,0c-3.48-4.27-10.44-11.39-13.31-14.29l8-8.55,6.09-.66S521.66,209.77,527.23,231.81Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M469.86,176.84c-2.19,1.59-3.27,3.84-2.41,5l57.75,79.62c.87,1.19,3.34.87,5.53-.72s3.27-3.84,2.41-5l-57.76-79.62C474.52,174.93,472.05,175.25,469.86,176.84Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M475.38,176.12l57.76,79.62c.85,1.19-.22,3.44-2.41,5s-4.66,1.91-5.52.72l-57.75-79.62a2.47,2.47,0,0,1,.21-2.65,6.1,6.1,0,0,1,1.09-1.43,8.65,8.65,0,0,1,1.1-.95C472,175.26,474.52,174.93,475.38,176.12Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M533.14,255.74c.85,1.19-.22,3.44-2.41,5s-4.66,1.91-5.52.72c-.48-.65.72-1.64,1.41-3.08l-58.95-79.19a6.1,6.1,0,0,1,1.09-1.43l57.76,79.63a9.16,9.16,0,0,1,1.09-.95C529.8,254.88,532.28,254.56,533.14,255.74Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M462.71,174.63c-1.85,2-2.48,4.39-1.41,5.4l71.8,67.22c1.07,1,3.44.22,5.29-1.76s2.48-4.39,1.41-5.39L468,172.87C466.92,171.87,464.56,172.66,462.71,174.63Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M468,172.87,539.8,240.1c1.07,1,.44,3.42-1.41,5.39s-4.22,2.76-5.28,1.76L461.3,180a2.49,2.49,0,0,1-.3-2.64,6.24,6.24,0,0,1,.81-1.61,8.31,8.31,0,0,1,.9-1.14C464.55,172.66,466.92,171.87,468,172.87Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M539.8,240.1c1.07,1,.44,3.42-1.41,5.39s-4.22,2.76-5.28,1.76c-.6-.56.39-1.75.79-3.29L461,177.38a6.24,6.24,0,0,1,.81-1.61L533.62,243a9.26,9.26,0,0,1,.89-1.14C536.36,239.89,538.73,239.1,539.8,240.1Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M480,389.18l-5.47.09c-5.57-26.13-9.5-58.47-11.95-82.87-.38-3.82-.73-7.44-1-10.82-.14-1.61-.28-3.15-.41-4.63-.66-7.34-1.11-13.15-1.38-16.75-.2-2.62-.29-4.06-.29-4.06H479.2l-.19,5-.61,16.63-.07,1.9-.41,11-.69,18.7C484,349.73,480,389.18,480,389.18Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M524.34,387.78l-5.39,1c-10.79-27-20.92-61.49-27.51-85.61-1-3.74-2-7.24-2.8-10.41l-.12-.47c-1.66-6.29-2.94-11.31-3.74-14.49-.61-2.49-.95-3.86-.95-3.86l19.5-3.36,1.1,8.19,1.63,12,.32,2.36,1.1,8.21,3,22C521.61,348.21,524.34,387.78,524.34,387.78Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M506.06,290.84l-17.42,1.94-.12-.47c-1.66-6.29-2.94-11.31-3.74-14.49l19.65,1Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M479,275.18l-.61,16.63-.07,1.9-16.83,1.87c-.14-1.61-.28-3.15-.41-4.63-.66-7.34-1.11-13.15-1.38-16.75Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M463.8,407.34a11,11,0,0,1,3.42-1.86h0s3.73-3.7,5.52-14.83l4.88-1.27a4.16,4.16,0,0,1,4.44,1.73,2.29,2.29,0,0,1,.31.65,27.53,27.53,0,0,1,.52,3.61c.49,3.77.07,12.22.07,12.22h-.88l-.35-7.67c-.13-2.6-2.12.45-2.69,3.26s-1.79,5.79-7.5,5.93C464.88,409.24,462.11,409,463.8,407.34Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M482.23,391.2c.32-2.6.42-7.13.42-7.13l-10.84,1.2s1.31,5.15.23,9C477.5,392.86,482.23,391.2,482.23,391.2Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M507.91,407.34a11,11,0,0,1,3.42-1.86h0s3.73-3.7,5.52-14.83l4.88-1.27a4.16,4.16,0,0,1,4.44,1.73,2.29,2.29,0,0,1,.31.65,27.53,27.53,0,0,1,.52,3.61c.49,3.77.07,12.22.07,12.22h-.88l-.35-7.67c-.13-2.6-2.12.45-2.69,3.26s-1.79,5.79-7.5,5.93C509,409.24,506.22,409,507.91,407.34Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M526.34,391.2c.32-2.6.42-7.13.42-7.13l-10.84,1.2s1.31,5.15.23,9C521.61,392.86,526.34,391.2,526.34,391.2Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M507.94,285.47l-20.62,2.64-.8.09-4.24-15.54-1.12,16.66-22.09-1.16c-9.85-57.78,7-71.43,7-71.43l30,6c13.58,23.08,10.35,49.9,10.35,49.9Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M479.55,144.73c0,2.27-1,4.11-2.25,4.11s-2.24-1.84-2.24-4.11,1-4.1,2.24-4.1S479.55,142.47,479.55,144.73Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M494.36,158.5a1.57,1.57,0,0,1-.26.19,12.05,12.05,0,0,1-4.19,2.05c-4.43,1-7.46.41-9.43-1.59h0c-2.77-3-3.46-8.33-3.07-14.75a24.07,24.07,0,0,1,1.41-7.5s0-.1,0-.12.07-.19.11-.27a8.74,8.74,0,0,1,6.44-5.35,17.76,17.76,0,0,1,3.8-.43C501.7,130.6,504,151.34,494.36,158.5Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M494.1,158.69a11.74,11.74,0,0,1-4.19,1.87c-4.43,1-7.46.27-9.43-1.76a12.49,12.49,0,0,0,7.94-.65C490.22,157.33,492.21,157.75,494.1,158.69Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M495.37,170c.77,3.57-3.85,5-3.85,5-7.55-3.23-9-7.24-9-7.24,6.31-3.29,4.48-12.59,4.48-12.59l1.28.63,9,1.76s-2.49,4.8-2.82,5.89v0C492.79,169.21,495.37,170,495.37,170Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M478.8,136.81s-.69,8.79,7.63,12.56c0,0,3.58,9.12,8.84,9.25,7.17.17,13.49-10,11-20.43C503.06,124.71,482.63,123.62,478.8,136.81Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M482.22,146.85c0-1.37,1.1-3.68,3.23-3.36s3.43,5.75-2,7C482.68,150.63,482.21,149.7,482.22,146.85Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M494.1,127.48s-8.38-2.12-13,1.25c-5.41,3.93-7.46,8-1.06,14.32,0,0,14.07-4.56,18.74-3.59a50.28,50.28,0,0,1,8,2.32C507.78,132.49,498.77,125.58,494.1,127.48Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M482.22,144.73s2.24,10.13-1.25,18.75c0,0,19.89,6.9,26.81,3.16s.58-16.34.29-23.59-3.45-18-14-15.57S482.22,144.73,482.22,144.73Z"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 475.06,
    y1: 144.09,
    x2: 483.46,
    y2: 144.09
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M487.32,288.11l-.8.09-4.24-15.54s9.09-15.53,6.25-23.62C488.94,249.61,498.73,264.14,487.32,288.11Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M470.29,169.22s10-3.57,25.08.78S511,180.77,511,180.77s-9.55,21.65-11.06,46.16l-39.28-1.47S456,190.87,470.29,169.22Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M511,180.77s-9.55,21.65-11.06,46.16l-39.28-1.46a106.93,106.93,0,0,1-.72-12A118.76,118.76,0,0,1,461,195.91c1.31-9.08,4-18.76,9.26-26.69,0,0,10-3.57,25.07.78S511,180.77,511,180.77Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M469.74,197.38s-1.62,10-9.8,16.11A118.76,118.76,0,0,1,461,195.91Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M426.35,168.53l-5-7.35s-.77-3.19-1.72-3.92-10.47-4.76-11.62-4.74-1.14,7.41,0,8.66,7.15,3.95,8.72,4.23.81,0,.81,0l4.38,8.73Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M470.29,169.22A215.65,215.65,0,0,0,439.66,185l-16-21.81s-4.31,1.34-5.9,8.84c0,0,8.21,31.27,18.87,34.37s33.09-9,33.09-9S476.26,181.09,470.29,169.22Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M470.29,169.22A215.65,215.65,0,0,0,439.66,185l-16-21.81s-4.31,1.34-5.9,8.84c0,0,8.21,31.27,18.87,34.37s33.09-9,33.09-9S476.26,181.09,470.29,169.22Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M480.4,167.84s3.49,25,14.54,26,16-17.43,14.12-19.67S493,167.67,480.4,167.84Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M480.4,167.84s3.49,25,14.54,26,16-17.43,14.12-19.67S493,167.67,480.4,167.84Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "87.27 397.45 95.37 397.45 96.03 378.7 87.93 378.7 87.27 397.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.49,396.51H86.66a.71.71,0,0,0-.69.56l-1.6,7.21a1.19,1.19,0,0,0,.92,1.41l.26,0c3.19-.05,5.5-.25,9.5-.25,2.46,0,9.88.26,13.28.26s3.84-3.36,2.45-3.67c-6.24-1.36-10.94-3.24-12.93-5A2,2,0,0,0,96.49,396.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97,397.63a.19.19,0,0,1-.14-.16.18.18,0,0,1,.09-.19c.29-.18,2.91-1.79,3.8-1.32a.55.55,0,0,1,.33.53,1.13,1.13,0,0,1-.4,1,2.39,2.39,0,0,1-1.55.41A9.6,9.6,0,0,1,97,397.63Zm.56-.26a3.93,3.93,0,0,0,2.88-.15.78.78,0,0,0,.26-.69c0-.15-.07-.22-.12-.22a.43.43,0,0,0-.25-.05A7.68,7.68,0,0,0,97.6,397.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97,397.68a.21.21,0,0,1-.09-.18c0-.11.21-2.44,1.14-3.2a1,1,0,0,1,.82-.25.62.62,0,0,1,.61.51c.17.85-1.45,2.63-2.28,3.09H97.1A.2.2,0,0,1,97,397.68Zm1.3-3.15a4.56,4.56,0,0,0-1,2.53c.84-.63,1.87-2,1.76-2.5,0-.05,0-.2-.28-.2h-.09A.63.63,0,0,0,98.29,394.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "87.93 378.71 96.03 378.71 95.69 388.38 87.58 388.38 87.93 378.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "128.95 398.06 137.3 398.94 138.87 380.93 130.52 380.04 128.95 398.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.18,396.26h-9.83a.71.71,0,0,0-.69.55L126.07,404a1.18,1.18,0,0,0,.92,1.41,1.09,1.09,0,0,0,.26,0c3.18,0,5.5-.25,9.49-.25,2.46,0,9.89.26,13.28.26s3.84-3.36,2.45-3.67c-6.23-1.35-10.93-3.24-12.93-5A1.94,1.94,0,0,0,138.18,396.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138.74,397.38a.19.19,0,0,1-.14-.17.16.16,0,0,1,.09-.18c.29-.19,2.9-1.79,3.8-1.33a.6.6,0,0,1,.33.53,1.15,1.15,0,0,1-.4,1,2.48,2.48,0,0,1-1.56.42A9.51,9.51,0,0,1,138.74,397.38Zm.56-.27a3.93,3.93,0,0,0,2.88-.14.83.83,0,0,0,.26-.69c0-.16-.08-.23-.13-.23a.4.4,0,0,0-.24-.05A7.87,7.87,0,0,0,139.3,397.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138.69,397.42a.21.21,0,0,1-.09-.18c0-.11.2-2.44,1.14-3.2a1.08,1.08,0,0,1,.81-.25.63.63,0,0,1,.62.51c.17.85-1.45,2.63-2.29,3.09h-.09A.17.17,0,0,1,138.69,397.42Zm1.3-3.15a4.51,4.51,0,0,0-1,2.53c.83-.63,1.86-2,1.76-2.5,0-.05,0-.2-.28-.2h-.09A.63.63,0,0,0,140,394.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "130.52 380.04 138.87 380.93 138.05 390.22 129.7 389.34 130.52 380.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91.27,214.26h43c4.09,22.3,16.87,101.22,7.7,171.55L127.39,384s1.34-93.35-11.5-127.87c-1.48,18.47-3.23,38.13-4.75,48.59-3.74,25.73-11.74,82-11.74,82H84.6s3-53.84,4.42-79.13C90.55,280.1,91.22,219.9,91.27,214.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "143.59 389.19 125.59 386.52 126.14 381.53 144.87 383.99 143.59 389.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "101.18 386.82 83.72 386.82 83.72 381.61 101.84 381.26 101.18 386.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M115.9,256.14a115.74,115.74,0,0,1,4.79,18.58c1.2-16.44-3.6-33.87-3.6-33.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M90.06,221.73l-1,5.19s30.06,3.89,48.76,3.78l-.65-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M151.07,176.78s10.4,32.78,17.51,34.92,25.19-24.91,25.19-24.91,16.21-.15,16.93-1.26S206.49,173,205.31,173s-15.3,5.31-15.84,6.2-16.74,16.37-17.53,15.94S165,175.19,165,175.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M195.84,185.07l.39-.1-.19-.11A1.94,1.94,0,0,1,195.84,185.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M145.17,173l1.27,2.34,5.92,10.94,1.23,2.26,16.6-5.77s-6.9-25.78-9.3-28.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M145.17,173l1.27,2.34,5.92,10.94,1.23,2.26,16.6-5.77s-6.9-25.78-9.3-28.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M146.44,175.33l5.92,10.94c3.65-7.19,2.59-17,2.59-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M160.89,154.35a35.24,35.24,0,0,0-25-12.14c-16.27-.76-21.38.86-27.33,6.17C99.87,156.13,89.08,223,89.08,223a150.93,150.93,0,0,0,48.76,5.31s.2-18.55,6.07-31.06A348.06,348.06,0,0,0,160.89,154.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M89.08,223a150.91,150.91,0,0,0,48.77,5.31s0-2.28.31-5.8c.13-1.65.32-3.6.6-5.7s.66-4.5,1.15-6.87c.26-1.28.56-2.57.89-3.86a52,52,0,0,1,3.1-8.83q1.08-2.31,2.1-4.54c1.18-2.6,2.29-5.12,3.32-7.54,2.18-5.08,4.05-9.73,5.6-13.79,1.12-2.92,2.08-5.53,2.88-7.78.89-2.49,1.59-4.55,2.1-6.08.66-2,1-3.13,1-3.13a22,22,0,0,0-1.75-1.93,35.58,35.58,0,0,0-22.71-10.17l-.54,0c-12.4-.58-18.32.22-23.06,3a25,25,0,0,0-4.27,3.18,14.54,14.54,0,0,0-3,4.65,100.49,100.49,0,0,0-5,14.49c-.24.87-.47,1.76-.71,2.66-1.07,4-2.12,8.37-3.11,12.75-.28,1.23-.56,2.48-.83,3.72q-.61,2.85-1.19,5.66c-1,4.71-1.87,9.28-2.65,13.38-1.11,5.91-2,10.85-2.5,13.92C89.27,221.74,89.08,223,89.08,223Zm47.76-80.11c1.15,0,2.26.13,3.25.26,4.41.59,11.09,4.09,10.92,5.76s-2.72,5.9-9.25,4.87a16.18,16.18,0,0,1-6.34-2.65c-3.61-2.38-6.24-5.61-6.5-6.65C128.61,143.2,132.86,142.73,136.84,142.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122.81,165.11s-8.65,20.84-10.37,38.14l23.28,3s10.45-28.16,12.61-37C148.33,169.25,129.73,167.39,122.81,165.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "143.78 170.06 147.03 170.39 144.65 172.22 143.78 170.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M131.11,144.47c1.75,5,8.3,7.32,11.74,7.61a5.82,5.82,0,0,0,6.22-3.37s-3.91-2-3.53-4.15a10.34,10.34,0,0,1,1.62-3.74A21.71,21.71,0,0,1,148.5,139l-6.28-13.47C140.81,131.38,136.52,142.59,131.11,144.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M142,131.76c-3,6.53,1.24,11.07,3.58,12.8a10.34,10.34,0,0,1,1.62-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M163,114.26s2,11.1-3.79,15.56-6.38-16.3-6.38-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M163,114.26s2,11.1-3.79,15.56-6.38-16.3-6.38-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M142.32,139.17a10.14,10.14,0,0,0,11.73,3.59,11.33,11.33,0,0,0,6.29-5.42c.18-.35.35-.71.5-1.09,2.72-6.89,3.34-23.73-4-23.1-6,.52-11.93-1.35-15,3.87a11,11,0,0,0-1.51,4.87C139.64,129.88,138.88,134.55,142.32,139.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M152,125.82c-.13.63.17,1.21.6,1.27s.84-.42.94-1.06-.19-1.22-.6-1.28S152.13,125.16,152,125.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.34,126.85c-.14.64.18,1.22.6,1.28s.84-.42.93-1.07-.18-1.21-.6-1.27S159.43,126.24,159.34,126.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M157,126.84a23.31,23.31,0,0,0,2.31,6,3.83,3.83,0,0,1-3.19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.1,123.13a.4.4,0,0,0,.39-.1,3.1,3.1,0,0,1,2.61-.92.38.38,0,0,0,.45-.3.37.37,0,0,0-.29-.45h0a3.82,3.82,0,0,0-3.31,1.13.38.38,0,0,0,0,.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.84,124.78a.4.4,0,0,0,.22,0,.39.39,0,0,0,.25-.48h0a3.82,3.82,0,0,0-2.43-2.52.39.39,0,0,0-.47.27h0a.4.4,0,0,0,.27.47h0a3.09,3.09,0,0,1,1.89,2A.43.43,0,0,0,162.84,124.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M151,133.23s1.35,2.89,4.09,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M147.53,112.81l.1,3.56a2.64,2.64,0,0,0-1.63,3.18c.86,3.07-1.25,7.5-3.69,9.12,0,0,.05-1.29-1.06-1.09s-1.43,6.91.38,10.29c0,0-3.87-3.56-5-10.73-1.06-6.64-.88-10.85.07-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M147.53,112.81l.1,3.56a2.64,2.64,0,0,0-1.63,3.18c.86,3.07-1.25,7.5-3.69,9.12,0,0,.05-1.29-1.06-1.09s-1.43,6.91.38,10.29c0,0-3.87-3.56-5-10.73-1.06-6.64-.88-10.85.07-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136,117.09a36.86,36.86,0,0,0,11.66-.72c11-2.19,15.7,1.86,15.7,1.86a6.94,6.94,0,0,0,2.29-5.42c-.33-3.17-4.73-3.71-4.73-3.71s-1.33-3.57-4.24-4.65-5.85,1.62-5.85,1.62-3.64-3.51-7.88-2.51a6.36,6.36,0,0,0-5.08,6.19s-5,.51-4.87,3.06S136,117.09,136,117.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 152.88,
    cy: 126.35,
    rx: 3.57,
    ry: 4.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M165.43,127a3.61,3.61,0,1,1-3.57-4.12A3.87,3.87,0,0,1,165.43,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M156.45,126.84s1.15-.72,1.84.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M149.31,126.35l-6.27-.84a3.11,3.11,0,0,0-2.3.62l-.27.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M135.91,127.91a7.65,7.65,0,0,0,3.79,4.43c2.39,1.2,4.09-.82,3.86-3.35-.22-2.24-1.72-5.64-4.33-5.76S135.17,125.54,135.91,127.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M96,186.65c10.31-4.28,18.47-22,18.47-22l-5.86-3.54-8,6.39c-.24.87-.47,1.76-.71,2.66-1.07,4-2.12,8.37-3.11,12.75C96.52,184.16,96.24,185.41,96,186.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "152.79 188.53 170.59 181.99 171.09 183.5 153.29 189.84 152.79 188.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 52.25,
    y: 229.22,
    width: 52.22,
    height: 32.21,
    transform: "translate(39.4 -9.25) rotate(9.01)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "73.35 237.44 62.88 242.87 71.16 251.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "83.37 253.21 93.84 247.78 85.56 239.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 74.81,
    y1: 251.85,
    x2: 81.91,
    y2: 238.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M102.4,151.22S83,170.73,80.31,174.53s-7.72,45.83-7.72,45.83-1.07.37-1.16,1.28-.17,12.72,0,13.26,9.12,6.07,10.44,4.76S85,225,85,225l-4.72-4.62s5.49-31,8.92-36,17.6-15.75,17.6-15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.35,143.37c2.83,6,.68,18.63-4.54,23.09A153.4,153.4,0,0,1,95.33,179l-9.55-12.48s10.14-9.9,16.29-15.61C109.54,144,117.35,143.37,117.35,143.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M117.35,143.37c2.83,6,.68,18.63-4.54,23.09A153.4,153.4,0,0,1,95.33,179l-9.55-12.48s10.14-9.9,16.29-15.61C109.54,144,117.35,143.37,117.35,143.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "85.78 165.7 84.6 167.31 94.56 180.33 95.97 179.32 85.78 165.7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot201);
export default __webpack_public_path__ + "static/media/chatbot2-01.e26dce69fe68942d4be5f35946c12f5a.svg";
export { ForwardRef as ReactComponent };